import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'fz-empty-list',
  templateUrl: './empty-list.component.html',
  styleUrls: ['./empty-list.component.scss'],
})
export class EmptyListComponent {
  @Input()
  header?: string;
  @Input()
  isLoggedIn: boolean | null | undefined = false;
  @Input()
  showLoginButton = true;
  @Input()
  src: string | null | undefined;
  @Input()
  buttonText: string | null;
  @Output()
  buttonEvent: EventEmitter<any> = new EventEmitter();
  @Input()
  loggedInMessage =
    `You haven't played any tournament so far, your results will be shown here after you finished your game`;
  @Input()
  loggedOutMessage = 'Please login to see all the details';

  @Output()
  loginEvent: EventEmitter<any> = new EventEmitter();

  onLogin($event: Event) {
    this.loginEvent.emit($event);
  }

  onButtonClicked() {
    this.buttonEvent.emit();
  }
}
